<div fxLayout="column" fxLayoutGap="12px">
    <div fxLayout="row" fxLayoutAlign="center start" class="full-width" fxFlexOffset="12px">
        <div fxLayout="row" fxLayoutAlign="center start" fxFlex.gt-md="20" fxFlex="50">
            <a [routerLink]="['/']" class="full-width">
               

            </a>
        </div>
    </div>
    <!--<div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="12px" class="full-width">
        <button mat-raised-button color="whatsapp" (click)="onClick('whatsapp')">
            <mat-icon svgIcon="whatsapp"></mat-icon>&nbsp;
            Whatsapp
        </button>
        <button mat-icon-button color="instagram" (click)="onClick('instagram')">
            <mat-icon svgIcon="instagram"></mat-icon>
        </button>
        <button mat-raised-button color="telegram" (click)="onClick('telegram')">
            <mat-icon svgIcon="telegram"></mat-icon>&nbsp;
            Telegram
        </button>
    </div>-->
    <div fxLayout="row" fxLayoutAlign="center center" class="full-width">
        <div fxLayout="column" fxLayoutAlign="center center" fxFlex.gt-md="30" fxFlex="80">
            <span class="mat-h2" style="opacity: .8;font-weight: 300;">¡Escoge la farmacia de tu preferencia!</span>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center start" class="full-width margin-bottom">
        <div fxFlex.gt-md="35" fxFlex="90">
            <owl-carousel-o [options]="customOptions" #carruselPrincipal>
                <ng-container *ngFor="let banner of (banners$ | async)">
                    <ng-template carouselSlide>
                        <img [src]="banner.fuente" class="imagenes-banner">
                    </ng-template>
                </ng-container>

            </owl-carousel-o>
        </div>
    </div>
</div>